import {networkService as network} from '@/services'
import store from '@/store'

export const entityService = {

  getEntities() {
    return new Promise((resolve, reject) => {
      network
        .get(`/entity-statuses/all/en`)
        .then((data) => {

          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getEntityId(id) {
    return new Promise((resolve, reject) => {
      network
          .get(`/entity-statuses/${id}?locale=en`)
          .then((data) => {

            resolve(data.data)
          })
          .catch((err) => {
            reject(err)

          })
    })
  },

  createEntity({locale, name}) {
    return new Promise((resolve, reject) => {
      const request = {locale, name}
      network
        .post(`/entity-statuses`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updateEntityId({id, locale, name}) {
    return new Promise((resolve, reject) => {
      const request = {id, locale, name}
      network
        .put(`/entity-statuses/${id}`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  deleteEntity(id) {
    return new Promise((resolve, reject) => {
      network
        .delete(`/entity-statuses/${id}`)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}